import React from 'react'
import { formatDate } from '../../../../_common/core/validation/normalizers'

const getAddressString = venue => {
  let addressString = ''

  if (venue?.streetNumber) {
    addressString += `${venue.streetNumber}, `
  }
  if (venue?.displayName) {
    addressString += `${venue.displayName}, `
  }
  if (venue?.city) {
    addressString += `${venue.city}, `
  }
  if (venue?.country) {
    addressString += `${venue.country}`
  }

  return addressString
}

const InfoBlock = ({ value, label }) =>
  !value ? null : (
    <div>
      {label && <span style={{ color: '#B0B6C0' }}>{label}</span>}
      <p>{value}</p>
    </div>
  )

export const SectionBlock = ({
  label,
  infoBlocks = [],
  isLastItem = false,
  icon,
  subLabel,
  subLabelIcon,
}) => (
  <div style={{ borderBottom: isLastItem ? 'none' : '1px solid #999' }}>
    <h4>
      {icon && <img alt="nodata" src={asset(icon)} style={{ width: 14, paddingBottom: 3, marginRight: 5 }} />}
      {label}
    </h4>
    <span style={{ display: 'flex' }}>
      {subLabelIcon && (
        <img
          alt="nodata"
          src={asset(subLabelIcon)}
          style={{ width: 14, paddingBottom: 3, marginRight: 5, marginBottom: 10 }}
        />
      )}
      <p style={{ fontSize: 10 }}>{subLabel}</p>
    </span>
    {infoBlocks.map(item => (
      <InfoBlock key={item.id} value={item.value} label={item.label} />
    ))}
  </div>
)

const LeftSection = ({ event }) => {
  const sectionBlocks = [
    {
      id: 'eventSchedule',
      label: 'Event Schedule',
      icon: '/resources/images/system_icons/events.svg',
      infoBlocks: [
        {
          id: 'starts',
          value: formatDate(event.startDate, 'D MMMM, h:mm a', 'YYYY-MM-DD T HH:mm:ss'),
          label: 'Starts',
        },
        {
          id: 'ends',
          value: formatDate(event.endDate, 'D MMMM, h:mm a', 'YYYY-MM-DD T HH:mm:ss'),
          label: 'Ends',
        },
        event.salesStartDate && {
          id: 'salesStarts',
          value: formatDate(event.salesStartDate, 'D MMMM, h:mm a', 'YYYY-MM-DD T HH:mm:ss'),
          label: 'Ticket Sales Starts',
        },
        {
          id: 'salesEnds',
          value: formatDate(event.salesEndDate, 'D MMMM, h:mm a', 'YYYY-MM-DD T HH:mm:ss'),
          label: 'Ticket Sales Ends',
        },
      ].filter(Boolean),
    },
    {
      id: 'eventDetails',
      label: 'Event Details',
      icon: '/resources/images/system_icons/details.svg',
      infoBlocks: [
        {
          id: 'eventId',
          value: event.id,
          label: 'Event ID',
        },
        {
          id: 'brandName',
          value: event.owner.displayName,
          label: 'Brand Name',
        },
      ],
    },
    {
      id: 'venueDetails',
      label: 'Venue Details',
      icon: '/resources/images/psychographics/Place.svg',
      infoBlocks: [
        {
          id: 'venueName',
          value: getAddressString(event.venue),
          label: '',
        },
      ],
    },
  ]

  return (
    <div className="left-section col-xs-4">
      <h3 style={{ marginTop: 10 }}>{event.displayName}</h3>
      {sectionBlocks.map((item, index) => (
        <SectionBlock
          key={item.id}
          label={item.label}
          infoBlocks={item.infoBlocks}
          isLastItem={index === sectionBlocks.length - 1}
          icon={item.icon}
        />
      ))}
    </div>
  )
}

export default LeftSection
